module.exports = branding => {
  return `img {
      max-width: 300px;
      max-height: 250px;
    }
    .text-content a {
      color: ${branding.primaryColour || '#333333'} !important;
    }
    p {
      font-family: ${branding.bodyFont || 'Arial'} !important;
    }
    .text-content li,
    .text-content p {
      font-size: 16px !important;
      color: ${branding.secondaryColour || '#333333'} !important;
      line-height: 28px;
    }
    h1 {
      line-height: 1.7em !important;
      font-family: ${branding.headerFont || 'Arial'} !important;
      color: ${branding.secondaryColour || '#333333'};
    }
    h2 {
      line-height: 1.7em !important;
      font-family: ${branding.bodyFont || 'Arial'} !important;
      color: ${branding.secondaryColour || '#333333'} !important;
    }

    .header-image td {
      padding: 0 !important;
    }
    .header-image img {
      max-height: 400px;
      max-width: inherit !important;
    }`;
};



// WEBPACK FOOTER //
// ./src/emails/components/style.js